// src/hooks/signals/useSignalSeries.ts
// React Query hook for signal snapshot series data

import { useQuery } from "@tanstack/react-query";
import {
  signalSeriesQueryOptions,
  type SignalSeriesParams,
} from "@/services/queries/signals/signalQueries";

/**
 * Hook to fetch time series data for a trading signal.
 *
 * @example
 * const { data, isLoading, error } = useSignalSeries({ signalName: "z_score" });
 */
export function useSignalSeries(params: SignalSeriesParams) {
  return useQuery(signalSeriesQueryOptions(params));
}
